<template>
  <main class="min-h-screen surface-50 flex flex-column">
    <header class="surface-0 border-bottom-1 border-100 px-3 md:px-5 py-3">
      <a href="/" class="inline-flex" aria-label="Return to the SATS home page">
        <img
          src="/images/sats_menubar_logo.webp"
          alt="South African Theological Seminary"
          class="h-3rem w-auto"
        />
      </a>
    </header>

    <PageNotFound v-if="isNotFound" class="flex-1" />

    <SiteEmptyState
      v-else
      class="flex-1"
      :eyebrow="`Error ${statusCode}`"
      title="Something went wrong"
      description="We couldn't load this page. Please try again, or return to the home page."
      icon="pi pi-exclamation-circle"
      heading-tag="h1"
    >
      <template #actions>
        <Button
          rounded
          label="Try again"
          icon="pi pi-refresh"
          class="w-full sm:w-auto"
          @click="retryPage"
        />
        <Button
          outlined
          rounded
          label="Return home"
          icon="pi pi-home"
          class="w-full sm:w-auto"
          @click="returnHome"
        />
      </template>
    </SiteEmptyState>
  </main>
</template>

<script setup lang="ts">
interface ErrorPageProps {
  error?: {
    statusCode?: number
  }
}

const props = defineProps<ErrorPageProps>()

const route = useRoute()
const statusCode = computed(() => Number(props.error?.statusCode) || 500)
const isNotFound = computed(() => statusCode.value === 404)

useSeoMeta({
  title: () => (isNotFound.value ? 'Page not found | SATS' : 'Something went wrong | SATS'),
  description: () =>
    isNotFound.value
      ? 'The page you requested could not be found.'
      : 'The requested page could not be loaded.',
  robots: 'noindex, nofollow',
})

const retryPage = () => clearError({ redirect: route.fullPath })
const returnHome = () => clearError({ redirect: '/' })
</script>
